import React from 'react';
import { Helmet } from 'react-helmet';
import Header from 'components/Headers/Header';
import AdminNavbar from 'components/Navbars/AdminNavbar';
import routes from 'routes';
import { useParams, RouteComponentProps } from 'react-router-dom';

// routes.js isn't converted to TS yet; this is the subset of its route-entry
// shape that getBrandText reads (collapse/views is dead code today — no entry
// in routes.js currently sets it — but kept as read there originally).
interface RouteEntry {
	path: string;
	layout: string;
	name: string;
	collapse?: boolean;
	views?: { path: string; name: string }[];
}

interface WithHeaderOptions {
	title?: string;
	stats?: boolean;
	isDisplayHeader?: boolean;
	isDisplayNav?: boolean;
	isHistoryBack?: boolean;
}

const withHeader = <P extends RouteComponentProps>(
	Component: React.ComponentType<P>,
	{ title, stats, isDisplayHeader, isDisplayNav, isHistoryBack }: WithHeaderOptions
) => (props: P) => {
	const { name } = useParams<{ name?: string }>();
	const userInfo = { name: 'admin' }; //getUserInfo();
	const getBrandText = () => {
		const { location } = props;
		const routeList = routes as RouteEntry[];
		for (let i = 0; i < routeList.length; i++) {
			if (
				location.pathname.indexOf(routeList[i].layout + routeList[i].path) !==
				-1
			) {
				return routeList[i].name;
			}

			if (routeList[i].collapse && routeList[i].views!.length !== 0) {
				let founded = routeList[i].views!.find(
					(sub) =>
						location.pathname.indexOf(
							routeList[i].layout + sub.path
						) !== -1
				);
				if (founded) return founded.name;
			}
		}
		return 'Brand';
	};
	return (
		<>
			<Helmet title={title || 'Not have title'} />
			{isDisplayNav && (
				<AdminNavbar
					{...props}
					userInfo={userInfo}
					brandText={getBrandText()}
				/>
			)}
			<Header
				title={title || name || 'Not have title'}
				stats={stats}
				isDisplayHeader={isDisplayHeader}
				isHistoryBack={isHistoryBack}
			/>
			<Component {...props} />
		</>
	);
};
export default withHeader;
